import React from 'react';
import Relay from 'react-relay';
import { applyRouterMiddleware } from 'react-router';
import useRelay from 'react-router-relay';
import { Observable } from 'rxjs/Observable';
import { handleSentryError } from '../modules/handle-error';

const NullEnvironment = () => {
  const env = new Relay.Environment();
  env.injectNetworkLayer({
    sendMutation(_mutationRequest) {
      // ... no-op
    },
    sendQueries(_queryRequests) {
      // ... no-op
    },
    supports(..._options) {
      return false;
    }
  });
  return env;
};

let pendingMutations = 0;
const observing = [];
const fireAllComplete = () => observing.forEach((o) => o());
const allComplete = Observable.create((observer) => {
  if (pendingMutations === 0) {
    observer.next({});
  }
  const index = observing.push(() => observer.next({})) - 1;
  return () => delete observing[index];
});

const RelayEnvironment = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      environment: new NullEnvironment()
    };
    RelayEnvironment.instance = this;
  }

  static resetWithToken(token) {
    const environment = new Relay.Environment();
    environment.injectNetworkLayer(
      new Relay.DefaultNetworkLayer('/api/graphql', {
        headers: {
          'x-rg-auth': token
        }
      })
    );
    RelayEnvironment.instance.setState({ environment });
  }

  static reset() {
    RelayEnvironment.instance.setState({ environment: new NullEnvironment() });
  }

  static allMutationsComplete() {
    return allComplete;
  }

  static commitUpdate(mutation, handlers) {
    pendingMutations += 1;
    return RelayEnvironment.instance.state.environment.commitUpdate(mutation, {
      onSuccess: (...args) => {
        pendingMutations -= 1;
        if (pendingMutations === 0) {
          fireAllComplete();
        }
        return handlers.onSuccess && handlers.onSuccess(...args);
      },
      onFailure: (...args) => {
        pendingMutations -= 1;
        if (pendingMutations === 0) {
          fireAllComplete();
        }
        handleSentryError(args[0].getError());
        return handlers.onFailure && handlers.onFailure(...args);
      }
    });
  }

  render() {
    return React.cloneElement(this.props.children, {
      environment: this.state.environment,
      render: applyRouterMiddleware(useRelay)
    });
  }
};

export default RelayEnvironment;



// WEBPACK FOOTER //
// ./src/components/relay-environment.js